import React from "react";
import Page from "./Page";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Page />
    </div>
  );
}

export default App;
